import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAlbum } from '../contexts/AlbumContext';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import MusicServiceSelector from '../components/features/music/MusicServiceSelector';
import HorizontalRule from '../components/common/HorizontalRule'

const Settings = () => {
  const navigate = useNavigate();
  const { refreshData } = useAlbum();
  const [initialUserId, setInitialUserId] = useState(() => localStorage.getItem('albumGeneratorUser') || '');
  const [userId, setUserId] = useState(initialUserId);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hasChanged, setHasChanged] = useState(false);

  const [preferredService, setPreferredService] = useState(() =>
    localStorage.getItem('preferredMusicService') || 'spotify'
  );

  const handleServiceChange = (service) => {
    localStorage.setItem('preferredMusicService', service);
    setPreferredService(service);
  };

  useEffect(() => {
    setHasChanged(userId !== initialUserId);
  }, [userId, initialUserId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const trimmedUserId = userId.trim();
    if (!trimmedUserId) {
      setError('Please provide a Project Name');
      setIsLoading(false);
      return;
    }

    try {
      localStorage.setItem('albumGeneratorUser', trimmedUserId);
      const refreshResult = await refreshData();

      if (refreshResult?.success) {
        setInitialUserId(trimmedUserId);
        navigate('/today');
      } else {
        setError('Project not found');
        localStorage.removeItem('albumGeneratorUser');
      }
    } catch (err) {
      setError(err.message || 'Failed to connect to project');
      localStorage.removeItem('albumGeneratorUser');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col flex-1 w-full items-center sm:pt-12 sm:pb-24 py-8 sm:gap-16 gap-8 text-amber-50">

      <div className="flex flex-col w-full items-center gap-4">

        <div className="uppercase pangram-sans-bold max-sm:text-sm tracking-wider">
          1001 AG Project
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col w-full gap-4">
          <input
            className="w-full md:pt-6 md:pb-7 pt-4 pb-5 text-center outline-none placeholder:text-black/20 text-black rounded-full bg-amber-50
                     pangram-sans-bold xl:text-7xl lg:text-6xl md:text-5xl text-4xl"
            id="userId"
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            placeholder="project-name"
            disabled={isLoading}
            autoComplete="off"
            autoFocus
          />

          {error && (
            <p className="mt-2 text-red-500 text-3xl text-center">{error}</p>
          )}

          {hasChanged && (
            <div className="flex justify-center md:mt-6 mt-2">
              {isLoading ? (
                <LoadingSpinner />
              ) : (
                <button
                  type="submit"
                  className="
                    flex items-center justify-center xl:w-[36rem] lg:w-[28rem] md:w-[24rem] w-[18rem] px-8 md:py-4 py-2
                    xl:text-5xl lg:text-4xl md:text-3xl text-2xl
                    uppercase pangram-sans-bold tracking-wider outline-none border-4 
                    border-solid border-amber-50 rounded-full"
                >
                  Connect
                </button>
              )}
            </div>
          )}
        </form>

      </div>

      <HorizontalRule direction="y" unit="2" />

      <MusicServiceSelector
        selectedService={preferredService}
        onServiceChange={handleServiceChange}
      />

    </div>
  );
};

export default Settings;